import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { HeaderComponent } from './component/header/header.component';
import { CustomDatePipe } from '../_pipe/datepipe.pipe';
import { AppMaterialModule } from '../_material/material.module';
import { CustomDateRangeComponent } from './component/custom-date-range/custom-date-range.component';
import { dateRangeComponent } from './component/date-range/date-range.component';
import { searchDropDownFilter } from '../_pipe/search-filter.pipe';
import { PanelMenuModule } from 'primeng/panelmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MessageService } from 'primeng/api';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastModule } from 'primeng/toast';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { MegaMenuModule } from 'primeng/megamenu';
import { ChangeColorModalComponent } from './component/change-color-modal/change-color-modal.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { DialogModule } from 'primeng/dialog';
import { ChangePasswordModalComponent } from './component/change-password-modal/change-password-modal.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Timeline, TimelineModule } from 'primeng/timeline';
import { ReferComponent } from './component/refer/refer.component';
import { IndianNumberFormatDirective } from '../_directive/indian-number-format.directive';
@NgModule({
  declarations: [
    CustomDatePipe,
    CustomDateRangeComponent,
    dateRangeComponent,
    searchDropDownFilter,
    ChangeColorModalComponent,
    ChangePasswordModalComponent,
    ReferComponent,
    IndianNumberFormatDirective
  ],
  exports: [
    CustomDatePipe,
    CustomDateRangeComponent,
    dateRangeComponent,
    searchDropDownFilter,
    OverlayPanelModule,
    TieredMenuModule,
    NgSelectModule,
    ToastModule,
    ChangeColorModalComponent,
    FormsModule,
    ColorPickerModule,
    MegaMenuModule,
    ImageCropperComponent,
    DialogModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    ChangePasswordModalComponent,
    TableModule,
    TimelineModule, CardModule, ButtonModule,
    IndianNumberFormatDirective
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    PanelMenuModule,
    OverlayPanelModule,
    TieredMenuModule,
    NgSelectModule,
    ToastModule,
    FormsModule,
    ColorPickerModule,
    MegaMenuModule,
    ImageCropperComponent,
    DialogModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    TableModule,
    TimelineModule, CardModule, ButtonModule
  ],
  providers: [DialogService],
})

// @NgModule({
//   declarations: [
//     HeaderComponent,
//     SidebarComponent
//   ],
//   imports: [
//     CommonModule
//   ],
//   exports:[
//     HeaderComponent,
//     SidebarComponent
//   ]
// })
export class SharedModule {}
